import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I start earning with SurveysIQ?",
      answer:
        "Simply sign up, complete your profile, and start receiving surveys tailored to you. The more accurate your profile, the better your survey matches!",
    },
    {
      question: "How much can I earn per survey?",
      answer:
        "Earnings vary based on the length and type of survey, but most surveys pay between ₹10 to ₹200 or more.",
    },
    {
      question: "How do I receive my earnings?",
      answer:
        "You can cash out your earnings via UPI, Paytm, or bank transfer once you reach the minimum withdrawal limit.",
    },
    {
      question: "Are the surveys legit and safe?",
      answer:
        "Yes! We only partner with verified market research companies. Your data is always protected and never sold.",
    },
    {
      question: "How often will I get new surveys?",
      answer:
        "Survey availability 24/7 (Always) from partners. Make sure to keep your profile updated to receive more relevant surveys.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="bg-green-50 px-8 py-12">
      <div className="mx-auto max-w-90vw">
        <h2 className=" font-bold text-left font-sans text-[40px] sm:text-5xl mt-8 break-words leading-[61px] mb-8 text-gray-800">
          FAQs
        </h2>

        <div className="space-y-6 pb-10">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 ${
                openIndex === index ? "py-4" : ""
              }`}
            >
              <button
                className="w-full p-6 flex items-center justify-between text-left"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-xl font-semibold font-sans text-gray-800">
                  {faq.question}
                </h3>
                {openIndex === index ? (
                  <Minus className="text-gray-500" />
                ) : (
                  <Plus className="text-gray-500" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-gray-700 text-base font-sans">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
